export default {
    bindings: {
        'fullscreen': '<',
        'isOpen': '=',
        'eventType': '=',
        'query': '@',
    },
    controller: 'searchFormController',
    template: require('../views/searchForm.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/searchForm.component.js